import React from 'react';
import styled, { css } from 'styled-components/macro';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faInfoCircle, faCheckCircle } from '@fortawesome/free-solid-svg-icons';
import { theme } from 'styled-tools';
import { isValidMobileNumber } from 'utils/mobileNumberValidation';

const UnconfirmedIcon = styled(FontAwesomeIcon).attrs({
  icon: faInfoCircle,
})`
  margin-left: 0.25rem;
  color: ${theme('colors.red')};
`;

const ConfirmedIcon = styled(FontAwesomeIcon).attrs({
  icon: faCheckCircle,
})`
  margin-left: 0.25rem;
  color: ${theme('colors.primary')};
`;

const LabelWrapper = styled.span`
  color: ${theme('colors.red')};
  ${props =>
    props.$confirmed &&
    css`
      color: ${theme('colors.primary')};
    `}
`;

const ConfirmedUnconfirmed = ({ isMobileNumberVerified, mobileNumber }) => {
  if (!mobileNumber) return <></>;

  if (!isMobileNumberVerified)
    return (
      <LabelWrapper>
        <UnconfirmedIcon /> {isValidMobileNumber(mobileNumber) ? 'Unconfirmed' : 'Invalid'}
      </LabelWrapper>
    );

  return (
    <LabelWrapper $confirmed>
      <ConfirmedIcon /> Confirmed
    </LabelWrapper>
  );
};

export default ConfirmedUnconfirmed;
